import { gql } from "apollo-angular";

export default gql`
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $filter: RegisteredCountriesFilterInput
  ) {
    updateCompany(input: $input) {
      id
      name
      account {
        id
        name
      }
      countryCode
      vatNumber
      createdAt
      contacts {
        name
        email
        phone
        mobile
        linkedIn
      }
      registeredCountries(filter: $filter) {
        objects {
          countryCode
          vatNumber
          registrationPeriod {
            from
            to
          }
        }
      }
      address {
        addressType
        addressLine1
        addressLine2
        extraInformation
        streetName
        streetNumber
        city
        region
        postalCode
        countryCode
      }
      partialExemptionType
      bankDetails {
        name
        accountNumber
        ibanNumber
        bankNumber
        sortCode
      }
      vatPortals {
        type
        id
      }
      enabledProducts
      companySourceEntity
      type
      status
      inactiveReason
      inactiveDescription
    }
  }
`;
